import React from 'react';
import { Link } from '@inertiajs/react';
import {
    Pagination,
    PaginationContent,
    PaginationItem,
    PaginationLink,
} from './ui/pagination';

export default function Paginator({ links }) {
    if (!links || links.length <= 3) {
        return null;
    }

    return (
        <Pagination className="mt-4">
            <PaginationContent>
                {links.map((link, index) => {
                    const isFirst = index === 0;
                    const isLast = index === links.length - 1;
                    const label = isFirst ? '‹' : isLast ? '›' : link.label;

                    return (
                        <PaginationItem key={index}>
                            {link.url ? (
                                <PaginationLink
                                    href={link.url}
                                    as={Link}
                                    isActive={link.active}
                                    size="sm"
                                    className={`text-[14px] no-underline ${link.active ? 'font-bold text-[#003545]' : 'font-normal text-[#003545]'} ${(isFirst || isLast) ? 'font-bold text-lg' : ''}`}
                                >
                                    {label}
                                </PaginationLink>
                            ) : (
                                <span className="inline-flex items-center justify-center h-9 px-2 text-[14px] text-gray-300">
                                    {label}
                                </span>
                            )}
                        </PaginationItem>
                    );
                })}
            </PaginationContent>
        </Pagination>
    );
}
